import { LucideIcon } from 'lucide-react';

export type ResultadoType = 'Resolvida' | 'Aceita' | 'Recusada' | null;
export type StatusKanbanType = 'Pendentes' | 'Em Andamento' | 'Concluídas';

export const STATUS_CONCLUIDAS: StatusKanbanType = 'Concluídas';

export interface ArquivoPendencia {
  id_proposta_arquivo: number;
  caminho: string;
  tipo_arquivo?: string;
  tamanho?: number;
  excluido?: boolean;
}

export interface PendenciaKanban {
  id_pendencia: number;
  id_proposta: number;
  tipo: string;
  descricao: string;
  valor?: number;
  destino: string;
  resolvida?: string;
  status_kanban: StatusKanbanType;
  resultado?: ResultadoType;
  resposta?: string | null;
  criado: string;
  modificado: string;
  origem?: 'Correspondente' | 'Solicitante' | 'Operador';
  criadorNome?: string;
  destinatarioNome?: string | null;
  solicitanteNome?: string | null;
  id_responsavel?: number | null;
  id_destino?: number | null;
  tipo_responsavel?: string | null;
  arquivos?: ArquivoPendencia[];
}

export interface ColunaKanban {
  id: StatusKanbanType;
  title: string;
  icon: LucideIcon;
  bgColor: string;
  iconColor: string;
}
